import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation } from 'react-router';

import styles from './styles/styles.module.css';

function Checkbox({ label, checkboxName, onChange, smallSize, labelFont, disable }) {
  const [isChecked, setIsChecked] = useState(false);
  const { pathname } = useLocation();
  const isPhoneForm = pathname === '/registration/phone';
  const handleToggle = () => {
    setIsChecked(!isChecked);
    onChange(!isChecked); // передаём новое значение isChecked вверх, в родительский компонент
  };

  return (
    <div className={styles.checkboxContainer}>
      <label
        className={styles.checkboxLabel}
        htmlFor={checkboxName}
        style={{ fontSize: labelFont || 'inherit' }}
      >
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={isChecked}
          onChange={disable ? () => {} : handleToggle}
          id={checkboxName}
          aria-hidden="true"
          disabled={disable}
        />
        <span
          className={`
              ${styles.checkbox_visible}
              ${smallSize ? styles.checkbox_small : ''}
              ${isChecked ? styles.checkbox_checked : ''}
              ${disable ? styles.checkbox_disabled : ''}
            `}
          role="switch"
          aria-checked={isChecked}
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsChecked(!isChecked);
            }
          }}
        />
        {isPhoneForm ? (
          checkboxName === 'oferta' ? (
            <span className={styles.labelText}>
              Соглашаюсь с условиями{' '}
              <a
                style={{ color: '#466F8C' }}
                href="https://ambar-sklad.ru/%d0%b4%d0%be%d0%b3%d0%be%d0%b2%d0%be%d1%80-%d0%be%d1%84%d0%b5%d1%80%d1%82%d0%b0/"
              >
                оферты
              </a>
            </span>
          ) : (
            <span className={styles.labelText}>
              Соглашаюсь с{' '}
              <a
                style={{ color: '#466F8C' }}
                href="https://ambar-sklad.ru/soglasie-na-obrabotku-personalnyh-dannyh/"
              >
                обработкой своих персональных данных
              </a>
            </span>
          )
        ) : (
          <span className={styles.labelText}>{label}</span>
        )}
      </label>
    </div>
  );
}

export default Checkbox;

Checkbox.propTypes = {
  label: PropTypes.string,
  checkboxName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  smallSize: PropTypes.bool,
  labelFont: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disable: PropTypes.bool,
};
